module.exports = __webpack_public_path__ + "img/project_2.335f059e.png";